import { getAllUsers } from "@/api/users";
import { RoleType, User } from "@/models/user.model";
import React, { useEffect, useState } from "react";
import UsersDataTable from "./table/UsersDataTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "@/app/store";
import { fetchAllUsers, fetchSearchResults } from "@/features/users/userSlice";
import { selectLeaveRequestsSearchResults } from "@/features/users/userSelector";

function UsersPage() {
  const dispatch: AppDispatch = useDispatch();
  const searchResults = useSelector(selectLeaveRequestsSearchResults);

  // const [users, setUsers] = useState<User[]>([]);
  const [isChange, setIsChange] = useState(false);
  const [search, setSearch] = useState("");

  // useEffect(() => {
  //   const fetchUsers = async () => {
  //     console.log(search);
  //     const role = RoleType.STAFF;
  //     const data = await getAllUsers({ search, role });
  //     setUsers(data);
  //   };
  //   fetchUsers();
  // }, [isChange, search]);

  useEffect(() => {
    const role = RoleType.STAFF;
    dispatch(fetchSearchResults({ search, role }));
  }, [dispatch, search]);

  return (
    <div className="flex flex-col h-[100vh] w-full p-4 gap-4">
      <UsersDataTable
        search={search}
        setSearch={setSearch}
        users={searchResults}
        setIsChange={setIsChange}
      />
    </div>
  );
}

export default UsersPage;
